var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Welcome",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-93.000000, -865.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(93.000000, 865.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFBDBD",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#D60000",
    fill: "#FFFFFF",
    cx: 22,
    cy: 22,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(20.000000, 13.000000)",
    fill: "#D60000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "4.96047647e-13 -6.21724894e-15 4.03427886 -6.21724894e-15 3.02224566 11 1.02224566 11"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7ee576b900ea4df79ab9b31c61966586.svg";
export { ForwardRef as ReactComponent };